import React from "react";
import PropTypes from "prop-types";
import { SELECT } from "@govlaunch/css-layers";

export default function TagsContainer({ children, css, innerRef, ...props }) {
  return (
    <div
      css={{
        position: "relative",
        minWidth: 350,
        zIndex: SELECT,
        ...css,
      }}
      ref={innerRef}
      {...props}
    >
      {children}
    </div>
  );
}

TagsContainer.propTypes = {
  children: PropTypes.node.isRequired,
  css: PropTypes.object,
  innerRef: PropTypes.func,
};

TagsContainer.defaultProps = {
  css: {},
  innerRef: null,
};
